import type { GICPayload } from '@atlassian/jira-packages-controllers-use-trigger-issue-create-modal/src/types.tsx';
import type { State } from '../../types';

export const getPayloadGlobalIssueCreate = (state: State): Partial<GICPayload> | undefined =>
	state.entities.globalIssueCreate.payloadGIC;
